// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__y-L2V","colBig":"styles_colBig__2cxkC","colSmall":"styles_colSmall__2KAa-"};